import aboutUs from './aboutUs';
import authentication from './authentication';
import isItalistLegitimate from './isItalistLegitimate';
import cart from './cart';
import charitableGiving from './charitableGiving';
import contactUs from './contactUs';
import customerService from './customerService';
import designer from './designer';
import designerList from './designerList';
import ipForm from './ipForm';
import main from './main';
import press from './press';
import privacy from './privacy';
import productDetail from './productDetail';
import productList from './productList';
import resetMyPassword from './resetMyPassword';
import reviews from './reviews';
import terms from './terms';

export {
  aboutUs,
  authentication,
  cart,
  charitableGiving,
  contactUs,
  customerService,
  designer,
  designerList,
  ipForm,
  isItalistLegitimate,
  main,
  press,
  privacy,
  productDetail,
  productList,
  resetMyPassword,
  reviews,
  terms,
};
